function isEventProp(propName) {
    return propName.substr(0, 3) === 'ev-';
}
function isNullOrUndefined(o) {
    return o === null || o === undefined;
}
var toString = Object.prototype.toString;
var isArray = Array.isArray || function (arr) {
    return toString.call(arr) === '[object Array]';
};
function isInvalid(o) {
    return o === null || o === false || o === true || o === undefined;
}
function isStringOrNumber(o) {
    var type = typeof o;
    return type === 'string' || type === 'number';
}
function isNull(o) {
    return o === null;
}
function isUndefined(o) {
    return o === void 0;
}
function isFunction(o) {
    return typeof o === 'function';
}
function isNumber(o) {
    return typeof o === 'number';
}
function isString(o) {
    return typeof o === 'string';
}
function isObject(o) {
    return o !== null && typeof o === 'object';
}
var ERROR_MSG = 'a runtime error occured! Use Intact in development environment to find the error.';
function throwError(message) {
    if (!message) {
        message = ERROR_MSG;
    }
    throw new Error("Intact Error: ".concat(message));
}
function error(message) {
    console.error(message);
}
var hasOwn = Object.prototype.hasOwnProperty;
var EMPTY_OBJ = {};
if (process.env.NODE_ENV !== 'production') {
    Object.freeze(EMPTY_OBJ);
}
var noop = function () { };
var hasDocumentAvailable = typeof document !== 'undefined';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function get(object, path) {
    if (hasOwn.call(object, path) || !isString(path))
        return object[path];
    var pathArray = castPath(path);
    var length = pathArray.length;
    var index = 0;
    while (!isNullOrUndefined(object) && index < length) {
        object = object[pathArray[index++]];
    }
    return (index && index === length) ? object : undefined;
}
function set(object, path, value) {
    if (process.env.NODE_ENV !== 'production') {
        if (typeof path === 'symbol') {
            throwError("set() does not support Symbol");
        }
    }
    var changeTraces = [];
    if (hasOwn.call(object, path)) {
        changeTraces.push({ path: path, newValue: value, oldValue: object[path] });
        object[path] = value;
        return changeTraces;
    }
    var pathArray = castPath(path);
    var length = pathArray.length;
    var lastIndex = length - 1;
    var index = -1;
    var nested = object;
    var prefix = '';
    while (!isNullOrUndefined(nested) && ++index < length) {
        var key = pathArray[index];
        var oldValue = nested[key];
        var newValue = value;
        if (index !== lastIndex) {
            // data is immutable, clone it before modifing it
            newValue = isObject(oldValue) ? clone(oldValue) : reIsIndex.test(pathArray[index + 1]) ? [] : {};
        }
        nested[key] = newValue;
        nested = nested[key];
        prefix += key;
        changeTraces.push({ path: prefix, newValue: newValue, oldValue: oldValue });
        prefix += '.';
    }
    return changeTraces;
}
var castPathCache = {};
var rePropName = /[^\.\[\]]+/g;
var reIsIndex = /^(?:0|[1-9]\d*)$/;
function castPath(path) {
    if (process.env.NODE_ENV !== 'production') {
        if (/^[\.\[\]]*$/.test(path)) {
            throwError('Encountered invalid path: ' + path);
        }
    }
    if (castPathCache[path])
        return castPathCache[path];
    return (castPathCache[path] = path.match(rePropName));
}
function clone(object) {
    if (process.env.NODE_ENV !== 'production') {
        if (!isObject(object)) {
            throwError('Encounterd invalid object: ' + JSON.stringify(object));
        }
    }
    if (isArray(object)) {
        return object.slice();
    }
    return __assign({}, object);
}

function proxyFragment(fragment) {
    var firstChild = fragment.firstChild, lastChild = fragment.lastChild;
    fragment._fragementFirstChild = firstChild;
    fragment._fragementLastChild = lastChild;
    Object.defineProperty(fragment, 'parentNode', {
        get: function () {
            return firstChild.parentNode;
        }
    });
    Object.defineProperty(fragment, 'nextSibling', {
        get: function () {
            return lastChild.nextSibling;
        }
    });
}
function proxyFragmentParent(fragment) {
    var parentNode = fragment.parentNode;
    if (!parentNode || parentNode._intactVueLegacyRewrote)
        return;
    var removeChild = parentNode.removeChild;
    parentNode.removeChild = function (child) {
        if (isFragmentDom(child)) {
            var lastChild = child._fragementLastChild;
            var sibling = child._fragementFirstChild;
            while (sibling && sibling !== lastChild) {
                var dom = sibling;
                sibling = sibling.nextSibling;
                removeChild.call(this, dom);
            }
            return removeChild.call(this, lastChild);
        }
        return removeChild.call(this, child);
    };
    var insertBefore = parentNode.insertBefore;
    parentNode.insertBefore = function (newChild, refChild) {
        if (refChild && isFragmentDom(refChild)) {
            return insertBefore.call(this, newChild, refChild._fragementFirstChild);
        }
        return insertBefore.call(this, newChild, refChild);
    };
    parentNode._intactVueLegacyRewrote = true;
}
function isFragmentDom(node) {
    return node.nodeType === 11; /* fragment */
}

export { EMPTY_OBJ, ERROR_MSG, error, get, hasDocumentAvailable, hasOwn, isArray, isEventProp, isFragmentDom, isFunction, isInvalid, isNull, isNullOrUndefined, isNumber, isObject, isString, isStringOrNumber, isUndefined, noop, proxyFragment, proxyFragmentParent, set, throwError, toString };
